<template>
  <section class="eventBox">
    <!--div class="eventTitle">Create an Event</div-->
    <div>
      <form class="event">
        <input
          autofocus
          class="event addTitle"
          v-model="title"
          type="text"
          click:clear
          placeholder="Add title"
        /><br />
        <!--div class="activitySelect">
          <div
            @click="toggleActivity('class')"
            class="activityOption class"
            :style="this.type == 'class' ? { opacity: '1' } : {}"
          >
            Class
          </div>
          <div
            @click="toggleActivity('assessment')"
            class="activityOption assessment"
            :style="this.type == 'assessment' ? { opacity: '1' } : {}"
          >
            Assessment
          </div>
          <div
            @click="toggleActivity('assignment')"
            class="activityOption assignment"
            :style="this.type == 'assignment' ? { opacity: '1' } : {}"
          >
            Assignment
          </div>
          <div
            @click="toggleActivity('office')"
            class="activityOption office"
            :style="this.type == 'office' ? { opacity: '1' } : {}"
          >
            Office Hours
          </div>
          <div
            @click="toggleActivity('other')"
            class="activityOption other"
            :style="this.type == 'other' ? { opacity: '1' } : {}"
          >
            Other
          </div>
        </div-->
        <div class="eventSplit">
          <div class="eventInfo">
            <div class="eventIcon">
              <img src="@/assets/Calendar/AddCalendarEvent/eventTime.svg" />
            </div>
            <div class="eventSubTitle">
              All Day
            </div>
          </div>
          <div
            class="toggleBox"
            @click="toggleAllDay"
            :class="{ toggledBox: allDay }"
          >
            <div class="toggleCircle" :class="{ toggledCircle: allDay }"></div>
          </div>
        </div>
        <div class="addRow">
          <div class="twoDates" style="padding-bottom: 10px; padding-top: 10px">
            <div class="oneDate">
              <Datepicker
                input-class="datePick"
                :placeholder="placeholder"
                :class="{ viewTime: !allDay }"
                v-model="startDate"
                maxDate="2021-04-30 11:59 pm"
              >
              </Datepicker>
              <input
                v-model="startTime"
                v-if="!allDay"
                :placeholder="curTime"
                class="timeDrop"
                type="text"
                list="firstTimeScroll"
              />
              <datalist id="firstTimeScroll" style="height: 50px">
                <div v-for="hour in timeHour" :key="hour.id">
                  <div v-for="minute in timeMinute" :key="minute.id">
                    <option>{{ hour }}:{{ minute }}AM</option>
                  </div>
                </div>
                <div v-for="hour in timeHour" :key="hour.id">
                  <div v-for="minute in timeMinute" :key="minute.id">
                    <option>{{ hour }}:{{ minute }}PM</option>
                  </div>
                </div>
              </datalist>
            </div>
            <div class="eventArrowIcon">
              <img src="@/assets/Calendar/AddCalendarEvent/eventArrow.svg" />
            </div>
            <div class="oneDate">
              <Datepicker
                input-class="datePick"
                :placeholder="placeholder"
                v-model="endDate"
                :class="{ viewTime: !allDay }"
                maxDate="2021-04-30 11:59 pm"
              >
              </Datepicker>
              <input
                v-model="endTime"
                v-if="!allDay"
                :placeholder="nextTime"
                class="timeDrop"
                type="text"
                list="lastTimeScroll"
              />
              <datalist id="lastTimeScroll">
                <div v-for="hour in timeHour" :key="hour.id">
                  <div v-for="minute in timeMinute" :key="minute.id">
                    <option>{{ hour }}:{{ minute }}AM</option>
                  </div>
                </div>
                <div v-for="hour in timeHour" :key="hour.id">
                  <div v-for="minute in timeMinute" :key="minute.id">
                    <option>{{ hour }}:{{ minute }}PM</option>
                  </div>
                </div>
              </datalist>
            </div>
          </div>
        </div>
        <div class="addRow">
          <div class="eventIcon">
            <img src="@/assets/Calendar/AddCalendarEvent/eventRepeat.svg" />
          </div>
          <div class="flexRow" v-if="chooseRepeat">
            <div class="repeatRow" @click="toggleRepeat()">Save repeat</div>
            <div class="repeatRow" @click="clearRepeat()">Remove repeat</div>
          </div>
          <div v-else class="repeatRow" @click="toggleRepeat()">
            <div v-if="repeatNum == 0">No repeat</div>
            <div v-else-if="repeatNum == 1">Every {{ repeatType }}</div>
            <div v-else>Every {{ repeatNum }} {{ repeatType }}s</div>
          </div>
        </div>
        <div v-if="chooseRepeat" class="repeatBox">
          <div class="repeatTypeSelect">
            <select
              v-if="repeatType == 'month'"
              class="selectDesign daySelect"
              v-model="repeatNum"
            >
              <option value="0" selected>No Repeat</option>
              <option value="1">Every 1</option>
              <option value="2">Every 2</option>
              <option value="3">Every 3</option>
              <option value="4">Every 4</option>
            </select>
            <select v-else class="selectDesign daySelect" v-model="repeatNum">
              <option value="0" selected>No Repeat</option>
              <option value="1">Every 1</option>
              <option value="2">Every 2</option>
              <option value="3">Every 3</option>
              <option value="4">Every 4</option>
              <option value="5">Every 5</option>
              <option value="6">Every 6</option>
              <option value="7">Every 7</option>
            </select>
            <select
              v-if="repeatNum < 2"
              class="selectDesign timeSelect event"
              v-model="repeatType"
            >
              <option value="week">Week</option>
              <option value="day" selected>Day</option>
              <option value="weekday">Weekday</option>
              <option value="month">Month</option>
            </select>
            <select
              v-else
              class="selectDesign timeSelect event"
              v-model="repeatType"
            >
              <option value="day" selected>Days</option>
              <option value="weekday">Weekdays</option>
              <option value="week">Weeks</option>
              <option value="month">Months</option>
            </select>
          </div>
          <div v-if="repeatType == 'week'" class="weekSelect">
            <div
              @click="toggleOption(8)"
              class="weekOptionTitle"
              :style="
                this.weekdays.length >= 7
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              Every Day
            </div>
            <div
              @click="toggleOption(0)"
              class="weekOption"
              :style="
                this.weekdays.includes(0)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              S
            </div>
            <div
              @click="toggleOption(1)"
              class="weekOption"
              :style="
                this.weekdays.includes(1)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              M
            </div>
            <div
              @click="toggleOption(2)"
              class="weekOption"
              :style="
                this.weekdays.includes(2)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              T
            </div>
            <div
              @click="toggleOption(3)"
              class="weekOption"
              :style="
                this.weekdays.includes(3)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              W
            </div>
            <div
              @click="toggleOption(4)"
              class="weekOption"
              :style="
                this.weekdays.includes(4)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              T
            </div>
            <div
              @click="toggleOption(5)"
              class="weekOption"
              :style="
                this.weekdays.includes(5)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              F
            </div>
            <div
              @click="toggleOption(6)"
              class="weekOption"
              :style="
                this.weekdays.includes(6)
                  ? { 'background-color': '#0fb9b1' }
                  : {}
              "
            >
              S
            </div>
          </div>
          <div class="repeatUntilRow" v-if="repeatNum > 0">
            <div class="repeatText">Repeat Until</div>
            <Datepicker
              input-class="smallDatePick"
              placeholder="30 Apr 2021"
              v-model="repeatFinish"
            >
            </Datepicker>
          </div>
        </div>
        <div class="addRow">
          <div class="eventIcon">
            <img src="@/assets/Calendar/AddCalendarEvent/eventReminder.svg" />
          </div>
          <div
            v-if="!chooseReminder && reminderSelect == 0"
            class="repeatRow"
            @click="toggleReminder()"
          >
            Set reminder
          </div>
          <div
            v-else-if="!chooseReminder"
            class="repeatRow"
            @click="toggleReminder()"
          >
            {{ reminderSelect }}
          </div>
          <div v-else class="flexRow">
            <div class="repeatRow" @click="toggleReminder()">Save reminder</div>
            <div class="repeatRow" @click="clearReminder()">
              Remove reminder
            </div>
          </div>
        </div>
        <div v-if="chooseReminder" class="repeatBox">
          <div class="reminderSelect">
            <select
              v-if="!moreReminder"
              class="selectDesign reminderOption"
              v-model="reminderSelect"
            >
              <option value="0">None</option>
              <option value="When event starts">When event starts</option>
              <option value="5 minutes before">5 minutes before</option>
              <option value="15 minutes before" selected
                >15 minutes before</option
              >
              <option value="1 hour before">1 hour before</option>
              <option value="1 day before">1 day before</option>
              <option v-if="hasCustomReminder" :value="reminderSelect">{{
                reminderSelect
              }}</option>
            </select>
            <div
              v-if="!moreReminder"
              @click="toggleMoreReminder()"
              class="reminderOption"
            >
              Custom ...
            </div>
            <div
              v-if="moreReminder"
              @click="saveCustomReminder()"
              class="reminderOption"
            >
              Save
            </div>
            <div
              v-if="moreReminder"
              class="reminderOption"
              @click="clearCustomReminder()"
            >
              Cancel
            </div>
          </div>
          <div
            v-if="moreReminder"
            class="repeatTypeSelect"
            style="margin-top: 0 !important"
          >
            <select
              v-if="reminderType == 'minutes'"
              class="selectDesign daySelect"
              v-model="reminderNum"
            >
              <option v-for="index in 60" :key="index" :value="index">{{
                index
              }}</option>
            </select>
            <select
              v-else-if="reminderType == 'hours'"
              class="selectDesign daySelect"
              v-model="reminderNum"
            >
              <option v-for="index in 24" :key="index" :value="index">{{
                index
              }}</option>
            </select>
            <select
              v-if="reminderType == 'days'"
              class="selectDesign daySelect"
              v-model="reminderNum"
            >
              <option v-for="index in 30" :key="index" :value="index">{{
                index
              }}</option>
            </select>
            <select class="selectDesign daySelect" v-model="reminderType">
              <option value="minutes" selected>minutes</option>
              <option value="hours">hours</option>
              <option value="days">days</option>
            </select>
          </div>
        </div>
        <div class="addRow">
          <div class="eventIcon">
            <img class="calendarImage" :src="groupOption.profileImage" />
          </div>
          <select class="selectGroup" v-model="groupOption">
            <option
              v-for="(group, index) in this.groupList"
              :key="index"
              :value="group"
              >{{ group.name }}</option
            >
          </select>
        </div>
        <div class="addRow">
          <div class="eventIcon">
            <div
              class="colorBlock"
              :style="{ 'background-color': chosenHex }"
            ></div>
          </div>
          <div class="repeatRow" @click="toggleColour()">
            {{ chosenColour }}
          </div>
        </div>
        <div v-if="chooseColour && !isCourse" class="repeatBox">
          <div class="colourRow">
            <div v-for="(colour, index) in listOfColours" :key="index">
              <div
                class="eventIcon"
                @click="pickColour(colour, listOfHex[index])"
              >
                <div
                  class="colorBlock"
                  :style="{ 'background-color': listOfHex[index] }"
                ></div>
                <span class="colorTitle">{{ colour }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="chooseColour && isCourse" class="repeatBox repeatBoxRow">
          <div class="weekOptionTitle" @click="pickColour('Class', '#0fb9b1')">
            Class
          </div>
          <div
            class="weekOptionTitle"
            @click="pickColour('Assessment', '#e74c3c')"
          >
            Assessment
          </div>
          <div
            class="weekOptionTitle"
            @click="pickColour('Assignment', '#f39c12')"
          >
            Assignment
          </div>
          <div
            class="weekOptionTitle"
            @click="pickColour('Office Hours', '#0984e3')"
          >
            Office Hours
          </div>
          <div class="weekOptionTitle" @click="pickColour('Other', '#a55eea')">
            Other
          </div>
        </div>
        <div v-if="toggleLocation" class="addRow">
          <div class="eventIcon">
            <img src="@/assets/Calendar/AddCalendarEvent/eventLocation.svg" />
          </div>
          <input
            class="event locationInput"
            v-model="location"
            type="text"
            placeholder="Location"
          />
        </div>
        <div v-if="toggleDescription" class="addRow">
          <div class="eventIcon">
            <img
              src="@/assets/Calendar/AddCalendarEvent/eventDescription.svg"
            />
          </div>
          <input
            class="event locationInput"
            v-model="description"
            type="text"
            placeholder="Description"
          />
        </div>
        <div v-if="!toggleDescription || !toggleLocation" class="addDetailsRow">
          <div class="eventIcon">
            <img src="@/assets/Calendar/AddCalendarEvent/eventExtra.svg" />
          </div>
          <div class="scrollDetails">
            <div
              class="addDetailsBox"
              v-if="!toggleLocation"
              @click="toggleDetail('location')"
            >
              <div class="eventIconSmall">
                <img
                  src="@/assets/Calendar/AddCalendarEvent/eventLocation.svg"
                />
              </div>
              <div>Location</div>
            </div>
            <div
              class="addDetailsBox"
              v-if="!toggleDescription"
              @click="toggleDetail('description')"
            >
              <div class="eventIconSmall">
                <img
                  src="@/assets/Calendar/AddCalendarEvent/eventDescription.svg"
                />
              </div>
              <div>Description</div>
            </div>
            <!--div
              class="addDetailsBox"
              v-if="!toggleInvite"
              @click="toggleDetail('invite')"
            >
              <div class="eventIconSmall">
                <img src="@/assets/Calendar/AddCalendarEvent/eventInvite.svg" />
              </div>
              <div>Invite</div>
            </div-->
          </div>
        </div>
        <p v-if="feedback" class="feedback">{{ feedback }}</p>
        <button class="submitButton" @click.prevent="addEvent">Submit</button>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import db from "@/db";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  props: ["day", "option"],

  components: {
    Datepicker,
  },

  data: () => ({
    title: "",
    allDay: true,
    chooseRepeat: false,
    chooseReminder: false,
    chooseColour: false,
    toggleLocation: false,
    toggleDescription: false,
    toggleInvite: false,
    moreReminder: false,
    hasCustomReminder: false,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    location: "",
    description: "",
    type: "class",
    repeatNum: 0,
    reminderSelect: "15 minutes before",
    reminderType: "minutes",
    reminderNum: 1,
    timeHour: [
      "12",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
    ],
    timeMinute: ["00", "15", "30", "45"],
    placeholder: "",
    repeatType: "week",
    repeatFinish: "",
    curTime: moment()
      .add(30 - moment().minute(), "minutes")
      .format("hh:mmA"),
    nextTime: moment()
      .add(30 - moment().minute(), "minutes")
      .add(1, "hour")
      .format("hh:mmA"),
    weekdays: [],
    feedback: null,
    listOfColours: [
      "River",
      "Pomagranate",
      "Clementine",
      "Mango",
      "Basil",
      "Sage",
      "Plum",
      "Lavendar",
      "Flamingo",
    ],
    listOfHex: [
      "#0984e3",
      "#d50105",
      "#f35220",
      "#f7bf27",
      "#087f41",
      "#30b679",
      "#3e52b4",
      "#7984ca",
      "#e67c73",
    ],
    chosenColour: "River",
    chosenHex: "#0984e3",
    groupList: [],
    groupOption: null,
    isCourse: false,
  }),

  computed: {
    ...mapState("messageBoard", [
      "groupId",
      "groupName",
      "curGroup",
      "groupType",
    ]),
    ...mapState("calendar", ["isAddingEvent"]),
    ...mapState("user", ["user"]),
  },

  mounted() {
    let dateValue = moment(this.day.date);
    this.placeholder =
      dateValue.format("DD") +
      " " +
      dateValue.format("MMM") +
      " " +
      dateValue.format("YYYY");
    if (this.option == "Week") {
      this.curTime = dateValue.format("hh:mm a");
      this.nextTime = dateValue.format("hh:mm a");
    }
    //var tmp = moment(this.day.date).format("DD MMM YYYY ") + this.curTime;
    //var endOfDay = (this.nextTime.includes("am")) ? 1 : 0;
    //var diff = ( (this.nextTime.includes("am") && Number(this.nextTime.substring(0,2)) == 12) || (this.nextTime.includes("pm") && Number(this.nextTime.substring(0,2)) != 12) ) ? 12 : 0;
    //console.log(this.getDateInMs(moment(this.day.date).set("hour", (Number(this.nextTime.substring(0,2)) + diff)).set("minutes", (Number(this.nextTime[3,4]) - endOfDay))));
    this.weekdays.push(moment(this.day.dateInMs).day());
    this.initiateGroups();
    this.checkIsCourse();
  },

  methods: {
    initiateGroups() {
      var personal = {
        name: "Personal Calendar",
        id: this.user.id,
        profileImage: this.user.profileImage,
      };
      this.groupList.push(personal);
      this.groupList = this.groupList.concat(this.user.groups);
      this.groupList = this.groupList.concat(this.user.faculties);
      this.groupList = this.groupList.concat(this.user.courses);
      this.groupOption = this.groupList[0];
    },
    checkIsCourse() {
      db.collection("courses")
        .doc(this.groupId)
        .get()
        .then(async (doc) => {
          this.isCourse = doc.exists;
          if (this.isCourse) {
            this.chosenColour = "Class";
            this.chosenHex = "#0fb9b1";
          }
        });
    },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      // Return array of year and week number
      return weekNo + 1;
    },
    toggleMoreReminder() {
      this.moreReminder = !this.moreReminder;
    },
    saveCustomReminder() {
      /*reminderSelect: "15 minutes before",
    reminderType: "minutes",
    reminderNum: 1,*/
      this.reminderSelect = this.reminderNum.toString();
      this.reminderSelect = this.reminderSelect.concat(" ");
      this.reminderSelect = this.reminderSelect.concat(this.reminderType);
      this.reminderSelect = this.reminderSelect.concat(" before");
      this.hasCustomReminder = true;
      this.moreReminder = false;
    },
    async addEvent() {
      if (this.title == "") {
        this.feedback = "Please enter a title";
        return;
      }
      var startDate = 0;
      var endDate = 0;
      var repeatEndDate = 0;
      var startTime = "";
      var endTime = "";
      //var diff = (this.nextTime.includes("pm") && Number(this.nextTime.substring(0,2) != 12) ) ? 12 : 0;
      //var zeroCase = (this.nextTime.includes("am") && Number(this.nextTime.substring(0,2)) == 12) ? 12 : 0;
      //var endOfDay = (this.nextTime.includes("am") && this.option != "Week") ? 1 : 0;

      if (this.startTime == "") {
        this.startTime = this.curTime;
      }
      if (this.endTime == "") {
        this.endTime = this.nextTime;
      }
      if (!this.allDay) {
        startTime = this.startTime;
        endTime = this.endTime;
      }

      /*
      let startHour = (Number(startTime.substring(0,2)) + diff - zeroCase);
      let startMin = (Number(this.startTime.substring(3,5)) - endOfDay);

      console.log(startHour)
      let endHour = (Number(endTime.substring(0,2)) + diff - zeroCase);
      let endMin = (Number(this.endTime.substring(3,5)) - endOfDay);*/

      startDate =
        this.startDate == ""
          ? this.getDateInMs(
              moment(this.day.date).format("DD MMM YYYY ") + startTime
            )
          : this.getDateInMs(
              moment(this.startTime).format("DD MMM YYYY ") + startTime
            );
      endDate =
        this.endDate == ""
          ? this.getDateInMs(
              moment(this.day.date).format("DD MMM YYYY ") + endTime
            )
          : this.getDateInMs(
              moment(this.endDate).format("DD MMM YYYY ") + endTime
            );
      repeatEndDate =
        this.repeatFinish == ""
          ? 1640969940000
          : this.getDateInMs(moment(this.repeatFinish).startOf("day"));

      if (startDate > endDate) {
        this.feedback = "Invalid Date/Time";
        return;
      }

      let curDate = this.getDateInMs(moment());
      let lastDate = 1640969940000;

      if (startDate < curDate) {
        this.feedback = "Start date cannot be before current date";
        return;
      }

      if (endDate > lastDate) {
        this.feedback = "End date cannot be after December 31st";
        return;
      }

      var weeks = this.setEventWeeks(startDate, endDate);
      var daysArray = [moment(startDate).dayOfYear()];
      for (
        let i = moment(startDate).dayOfYear() + 1;
        i < moment(endDate).dayOfYear();
        i++
      ) {
        daysArray.push(i);
      }

      var frequencyString =
        this.repeatNum == 1
          ? this.repeatType
          : this.repeatNum + " " + this.repeatType + "s";
      var weekString = this.weekdays.length == 0 ? "" : " on ";
      for (let week = 0; week < this.weekdays.length; week++) {
        weekString += moment()
          .set("date", this.weekdays[week])
          .format("ddd");
        if (week != this.weekdays.length - 1) {
          weekString += ", ";
        }
      }
      var endString = " until " + moment(repeatEndDate).format("ddd, MMM DD");

      var repeatsString =
        this.repeatNum == 0
          ? "No Repeat"
          : "Repeats every " + frequencyString + weekString + endString;

      var color;
      if (this.type == "class") {
        color = [22, 160, 133];
      } else if (this.type == "assessment") {
        color = [231, 76, 60];
      } else if (this.type == "assignment") {
        color = [243, 156, 18];
      } else if (this.type == "office") {
        color = [9, 132, 227];
      } else if (this.type == "other") {
        color = [9, 132, 227];
      } else {
        color = [0, 0, 0];
      }

      var event = {
        title: this.title,
        startDate: startDate,
        endDate: endDate,
        location: this.location,
        days: daysArray,
        frequency: this.repeatType,
        repeatInterval: this.repeatNum,
        repeatedDays: this.weekdays,
        repeatEndDate: repeatEndDate,
        group_id: this.groupId,
        weeks: weeks,
        user_id: this.user.id,
        isAllDay: this.allDay,
        type: this.type,
        description: this.description,
        repeatId: "",
        color: color,
      };

      var docId = await db.collection("calendarEvents").add(event);

      if (this.repeatNum > 0) {
        event.repeatId = docId.id;
        db.collection("calendarEvents")
          .doc(event.repeatId)
          .update(event);
        switch (this.repeatType) {
          case "day":
            this.repeatEvents(event, 86400000 * this.repeatNum, repeatEndDate);
            break;

          case "weekday":
            this.repeatWeekdayEvents(
              event,
              86400000 * this.repeatNum,
              repeatEndDate
            );
            break;

          case "week":
            this.repeatWeekEvents(
              event,
              86400000 * 7 * (this.repeatNum - 1),
              repeatEndDate
            );
            break;

          case "month":
            this.repeatEvents(
              event,
              86400000 * 30 * this.repeatNum,
              repeatEndDate
            );
            break;
        }
      }
      this.uploadCalendarEventPost(event, repeatsString, docId);
      this.resetData();
    },

    repeatEvents(event, dif, repeatDate) {
      while (event.startDate < repeatDate) {
        event.startDate += dif;
        event.endDate += dif;
        event.weeks = this.setEventWeeks(event.startDate, event.endDate);
        db.collection("calendarEvents")
          .doc()
          .set(event);
      }
    },

    repeatWeekEvents(event, dif, repeatDate) {
      while (event.startDate < repeatDate) {
        event.startDate += 86400000;
        event.endDate += 86400000;
        var dayNum = moment(event.startDate).day();
        if (this.weekdays.includes(dayNum)) {
          event.weeks = this.setEventWeeks(event.startDate, event.endDate);
          db.collection("calendarEvents")
            .doc()
            .set(event);
        }
        if (dayNum == 6) {
          event.startDate += dif;
          event.endDate += dif;
        }
      }
    },

    repeatWeekdayEvents(event, dif, repeatDate) {
      var dayNum = moment(event.startDate).day();
      while (event.startDate < repeatDate) {
        event.startDate += dif;
        event.endDate += dif;
        if (dayNum > 0 && dayNum < 6) {
          event.weeks = this.setEventWeeks(event.startDate, event.endDate);
          db.collection("calendarEvents")
            .doc()
            .set(event);
        } else if (dayNum == 6) {
          event.startDate += 86400000;
          event.endDate += 86400000;
        }
      }
    },
    toggleRepeat() {
      this.chooseRepeat = !this.chooseRepeat;
      this.chooseColour = false;
      this.chooseReminder = false;
    },
    toggleReminder() {
      this.chooseReminder = !this.chooseReminder;
      this.chooseRepeat = false;
      this.chooseColour = false;
    },
    toggleColour() {
      this.chooseColour = !this.chooseColour;
      this.chooseRepeat = false;
      this.chooseReminder = false;
    },
    pickColour(colourName, colourHex) {
      this.chosenColour = colourName;
      this.chosenHex = colourHex;
      this.toggleColour();

      if (this.isClass) {
        switch (colourName) {
          case "Class":
            this.type = "class";
            break;
          case "Assignment":
            this.type = "assignment";
            break;
          case "Office Hour":
            this.type = "office";
            break;
          case "Assessment":
            this.type = "assessment";
            break;
          case "Other":
            this.type = "other";
            break;
        }
      }
    },
    clearRepeat() {
      this.chooseRepeat = false;
      this.repeatNum = 0;
      this.repeatType = "week";
    },
    clearReminder() {
      this.chooseReminder = false;
      this.reminderSelect = 0;
    },
    clearCustomReminder() {
      this.moreReminder = false;
      this.reminderSelect = 0;
    },
    toggleDetail(detail) {
      if (detail == "location") {
        this.toggleLocation = true;
      } else if (detail == "description") {
        this.toggleDescription = true;
      } else if (detail == "invite") {
        this.toggleInvite = true;
      }
    },
    uploadCalendarEventPost(event, repeatsString, docId) {
      var content =
        this.user.firstName +
        " " +
        this.user.lastName +
        " added an event: " +
        "\n\n" +
        event.title +
        "\n\n" +
        this.getDateString(event);
      if (event.repeatInterval !== 0) {
        content += "\n\n" + repeatsString;
      }
      let post = {
        content: content,
        chat_id: this.groupId,
        created_at: Date.now(),
        event_id: docId.id,
      };
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set(post);

      post.id = id;
      this.curGroup.recentPosts.push(post);
      while (this.curGroup.recentPosts.length > 25) {
        this.curGroup.recentPosts.splice(0, 1);
      }
      db.collection(this.groupType)
        .doc(this.groupId)
        .update({
          recentPosts: this.curGroup.recentPosts,
        });
    },

    getDateString(event) {
      if (
        Number(moment(event.startDate).format("DD")) <
        Number(moment(event.endDate).format("DD"))
      ) {
        return (
          moment(event.startDate).format("ddd, MMM DD hh:mm a") +
          " - " +
          moment(event.endDate).format("ddd, MMM DD hh:mm a")
        );
      }
      if (event.isAllDay) {
        return moment(event.startDate).format("ddd, MMM DD") + "\nAll day";
      }
      return (
        moment(event.startDate).format("ddd, MMM DD") +
        "\n" +
        moment(event.startDate).format("hh:mm a") +
        " - " +
        moment(event.endDate).format("hh:mm a")
      );
    },

    setEventWeeks(startDate, endDate) {
      var startWeek = moment(startDate).week();
      var endWeek = moment(endDate).week();
      var weeks = [];

      for (var week = startWeek; week <= endWeek; week++) {
        weeks.push(week);
      }
      return weeks;
    },

    resetData() {
      this.title = "";
      this.startDate = "";
      this.endDate = "";
      this.location = "";
      this.$store.commit("calendar/setIsAddingEvent", false);
    },

    getDateInMs(date) {
      console.log(date);
      console.log(new Date(date).getTime());
      return new Date(date).getTime();
    },

    getWeekDay(date) {
      return new Date(date).getWeek();
    },

    toggleOption(num) {
      if (num == 8) {
        if (this.weekdays.length < 7) {
          for (var allNum = 0; allNum < 7; allNum++) {
            this.weekdays.push(allNum);
          }
        } else {
          for (var noNum = 0; noNum < 7; noNum++) {
            this.weekdays.splice(this.weekdays.indexOf(noNum), 1);
          }
          if (this.weekdays.length == 0) {
            this.weekdays.push(4);
          }
        }
      } else if (this.weekdays.includes(num) && this.weekdays.length > 1) {
        this.weekdays.splice(this.weekdays.indexOf(num), 1);
      } else {
        this.weekdays.push(num);
      }
    },
    toggleActivity(activity) {
      this.type = activity;
    },
    toggleAllDay() {
      this.allDay = !this.allDay;
    },
  },
};
</script>

<style scoped src="@/styles/components/AddCalendarEvent.css"></style>
